import script from "./project-person-add-alone.vue?vue&type=script&lang=tsx&setup=true"
export * from "./project-person-add-alone.vue?vue&type=script&lang=tsx&setup=true"

const __exports__ = script;

export default __exports__